// /frontend/src/locale/index.ts

/**
 * This file aggregates all locale JSON files into a single object
 * to be consumed by the i18n plugin.
 *
 * @author Alexander Funke
 * @lastChange 2025-09-15
 */

import csCZ from './cs-CZ.json';
import daDK from './da-DK.json';
import deDE from './de-DE.json';
import enUS from './en-US.json';
import esES from './es-ES.json';
import frFR from './fr-FR.json';
import itIT from './it-IT.json';
import plPL from './pl-PL.json';
import roRO from './ro-RO.json';
import svSE from './sv-SE.json';

export default {
  'cs-CZ': csCZ,
  'da-DK': daDK,
  'de-DE': deDE,
  'en-US': enUS,
  'es-ES': esES,
  'fr-FR': frFR,
  'it-IT': itIT,
  'pl-PL': plPL,
  'ro-RO': roRO,
  'sv-SE': svSE,
};
